import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Your Account", -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, "Your wallet: " + _toDisplayString(_ctx.farmerAcc.identity.toBase58()), 1),
    _createElementVNode("div", _hoisted_4, "MetaMounts staked: " + _toDisplayString(_ctx.farmerAcc.gemsStaked), 1),
    _createVNode(_component_FarmerRewardDisplay, {
      key: _ctx.farmerAcc.rewardA,
      farmReward: _ctx.farmAcc.rewardA,
      reward: _ctx.farmerAcc.rewardA,
      gems: _ctx.farmerAcc.gemsStaked,
      title: "Reward"
    }, null, 8, ["farmReward", "reward", "gems"])
  ]))
}